// ── Enums ──

export enum DayOfWeek {
  Monday = 0,
  Tuesday = 1,
  Wednesday = 2,
  Thursday = 3,
  Friday = 4,
  Saturday = 5,
  Sunday = 6,
}

export enum OverrideType {
  Add = 'add',
  Cancel = 'cancel',
  Modify = 'modify',
}

export enum CancelReason {
  OfficeClosure_Planned = 'office_closure_planned',
  OfficeClosure_Unplanned = 'office_closure_unplanned',
  LowAttendance = 'low_attendance',
  EventBasedChange = 'event_based_change',
  ServiceRelatedPause = 'service_related_pause',
  ReasonUnknown = 'reason_unknown',
}

export enum AddReason {
  MakeupDay = 'makeup_day',
  SpecialEvent = 'special_event',
  ExecutiveOrVIPVisit = 'executive_or_vip_visit',
  SeasonalOrHolidayCelebration = 'seasonal_or_holiday_celebration',
  ReasonUnknown = 'reason_unknown',
}

// ── Global Defaults (from existing ScheduleSettings on ClientSettings) ──

export interface GlobalScheduleDefaults {
  cutoffDaysBefore: number | null
  cutoffTime: number | null // 24hr integer
  dropoffTime: number | null // 24hr integer
}

// ── Domain Models ──

export interface Schedule {
  id: string
  clientSettingId: string
  name: string | null
  cycleLengthWeeks: number | null // null = purely ad hoc
  cycleAnchorDate: string // ISO date
  effectiveFrom: string // ISO date
  effectiveUntil: string | null // null = open-ended
  defaultCutoffDaysBefore: number | null
  defaultCutoffTime: number | null // 24hr integer e.g. 1400
  defaultDropoffTime: number | null // 24hr integer
  createdAt: string
  updatedAt: string
}

export interface ScheduleRule {
  id: string
  scheduleId: string
  cycleWeek: number // 1-indexed
  dayOfWeek: DayOfWeek
  cutoffDaysBefore: number | null
  cutoffTime: number | null
  dropoffTime: number | null
}

export interface ScheduleOverride {
  id: string
  scheduleId: string
  date: string // ISO date
  overrideType: OverrideType
  reason: AddReason | CancelReason | null
  notes: string | null
  cutoffDaysBefore: number | null
  cutoffTime: number | null
  dropoffTime: number | null
  createdBy: string
  createdAt: string
  updatedAt: string
}

// ── Time Resolution ──

export interface CutoffWindow {
  cutoffDaysBefore: number
  cutoffTime: number
}

export type TimeSource = 'global' | 'schedule' | 'rule' | 'override'

// ── Resolved Calendar Day ──

export type DayStatus = 'service' | 'no-schedule' | 'cancelled' | 'ad-hoc-on'

export interface ResolvedDay {
  date: string
  status: DayStatus
  source: 'rule' | 'override' | 'none'
  scheduleId: string | null
  cutoff: CutoffWindow | null // null when no service
  cutoffSource: TimeSource | null
  dropoffTime: number | null // 24hr integer, null when no service
  dropoffSource: TimeSource | null
  rule?: ScheduleRule
  override?: ScheduleOverride
}
